import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import Modal from "../../../Modal";
import Form, { Title, Submit, Cancel, Validation, Label } from "../../../Form";
import DateTime from "../../../DateTime";

import messages from "./messages";
import { IProps } from "./interfaces";

const ChangeDateModal = (props: IProps) => {
    const { close, modifyHomeworkDate } = props;
    const [date, setDate] = useState(new Date(props.date));
    const [startDate, setStartDate] = useState(new Date(props.startDate || Date.now()));
    const [dateValidation, setDateValidation] = useState<string | null>(null);
    const [startDateValidation, setStartDateValidation] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const handleModify = () => {
        if (date < new Date()) {
            setDateValidation("mustBeLater");
            return;
        }
        if (date <= startDate) {
            setStartDateValidation("mustBeOlder");
            return;
        }
        setLoading(true);
        modifyHomeworkDate(startDate, date, close, () => {
            setLoading(false);
        });
    };

    return (
        <Modal close={close}>
            <Title>
                <FormattedMessage {...messages.changeDate} />
            </Title>
            <Form disabled={loading}>
                <Label required>
                    <FormattedMessage {...messages.homeworkStartDate} />
                </Label>
                {startDateValidation && <Validation validation={startDateValidation} />}
                <DateTime date={startDate} onChange={setStartDate} disabled={loading} />
                <Label required>
                    <FormattedMessage {...messages.homeworkDate} />
                </Label>
                {dateValidation && <Validation validation={dateValidation} />}
                <DateTime date={date} onChange={setDate} disabled={loading} />
                <Submit onClick={handleModify} loading={loading}>
                    <FormattedMessage {...messages.modify} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}
export default ChangeDateModal;
